export const RestaurantsETL = (response) =>
  (response?.results || []).map((r) => ({
    id: r.id,
    name: r.name,
    lat: r.lat,
    lon: r.lon,
    tempClosed: r.temp_closed,
    tempClosedReason: r.temp_closed_reason,
    deliveryAvailable: r.delivery_available,
    takeoutAvailable: r.takeout_available,
  }));
